import React, { useState, useEffect, useRef } from "react";
import {
  Table,
  ScrollArea,
  rem,
  Text,
  UnstyledButton,
  Group,
  Center,
  Select,
  Button,
  Pagination,
  Checkbox,
  Modal,
  TextInput,
  Tabs, 
  Divider,
  Paper,
  Grid,
  Stack,
  NumberInput,
  Box,
  Skeleton,
  Breadcrumbs, 
  Anchor,
  MultiSelect,
  Code,
  Loader,
} from "@mantine/core";
import {
  IconPhoto,
  IconSettings,
  IconPhotoCancel
} from "@tabler/icons-react";
import { Dropzone } from "@mantine/dropzone";
import classes from "./PCComponentEdit.module.css";
import { showErrorAlert, showSuccessAlert } from "../../helper/alerts";
import useAxiosPrivate from "../../auth/useAxiosPrivate";
import Header from "../static/Header";
import { useQuery, useMutation, useQueryClient  } from 'react-query';
import { useForm } from '@mantine/form';
import { Link, useLocation, useParams } from "react-router-dom";

import { formatYYYY_MM_DD, formatYYYY_MM_DD_HH_mm } from "../../helper/DateTime";

export function PCComponentEdit() {
    const location = useLocation();
    const axiosPrivate = useAxiosPrivate();
    const queryClient = useQueryClient()
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(false);

    const getItemParamsQuery = useQuery(
        "getItemParamsQuery",
        async ({ signal }) => (await axiosPrivate.get("/api/admin/pc-components/get-item-params", { signal })).data.data,
        {
            initialData: null,
            onSuccess: (res) => {
                // console.log(res)
            },
            onError: () => {

            }
        }
    );

    const getPCComponentQuery = useQuery(
        "getPCComponent",
        async ({ signal }) => (await axiosPrivate.post("/api/admin/pc-components/get-item-by-id", { id }, { signal })).data.data,
        {
            initialData: null,
            onSuccess: (res) => {
                console.log(res)
                form.setValues({...res, cpuChipset: res.cpuChipset ? JSON.parse(res.cpuChipset) : [], gpuModel: res.gpuModel ? res.gpuModel.toString() : "" })
            },
            onError: () => {

            }
        }
    );

    const form = useForm({
        initialValues: {

            imgSrc: "",       ////  UPDATE THIS

            id: 0,
            displayName: "",
            price: 0,
            height: 0,
            width: 0,
            weight: 0,

            moboChipset: "",
            moboFormFactor: "",
            moboSocket: "",
            moboRamType: "",

            caseFormFactor: "",
            casePsuFormFactor: "",
            caseGpuLength: 0,
            caseCoolerHeight: 0,
            caseRadiatorLength: 0,

            coolerHeatExchangeMedium: "",
            coolerType: "",
            coolerSocket: "",
            coolerHeight: 0,
            coolerRadiatorLength: 0,

            ramType: "",
            ramDDR: "",
            ramAmount: 0,

            psuPCIE5: false,
            psuFormFactor: "",
            psu80PlusStandard: "",
            psuWattage: 0,

            ssdM2Type: "",
            ssdCapacity: "",
            ssdSize: "",

            cpuTdp: 0,
            cpuSocket: "",
            cpuChipset: [],

            gpuModel: "",
            gpuLength: 0,
            gpuRecommendedPsu: 0,
            
            show: false,
        },

        validate: {
            displayName: (value) => (value.trim().length < 1 ? 'Please fill in the fields' : null),
            // price: (value) => (value < 1 ? 'Invalid value' : null),
            // height: (value) => (value < 1 ? 'Invalid value' : null),
            // width: (value) => (value < 1 ? 'Invalid value' : null),
            // weight: (value) => (value < 1 ? 'Invalid value' : null),

            //  CPU
            cpuTdp: (value) => (getPCComponentQuery?.data?.xCategory === "PROCESSOR" && value < 1 ? 'Invalid value' : null),
            cpuSocket: (value) => (getPCComponentQuery?.data?.xCategory === "PROCESSOR" && value.trim().length < 1 ? 'Please select value' : null),
            cpuChipset: (value) => (getPCComponentQuery?.data?.xCategory === "PROCESSOR" && value.length < 1 ? 'Please select value' : null),

            //  GPU
            gpuModel: (value) => (getPCComponentQuery?.data?.xCategory === "VGA" && value.trim().length < 1 ? 'Please select value' : null),
            gpuLength: (value) => (getPCComponentQuery?.data?.xCategory === "VGA" && value < 1 ? 'Invalid value' : null),
            gpuRecommendedPsu: (value) => (getPCComponentQuery?.data?.xCategory === "VGA" && value < 1 ? 'Invalid value' : null),

            //  MOBO
            moboChipset: (value) => (getPCComponentQuery?.data?.xCategory === "MAINBOARD" && value.trim().length < 1 ? 'Please select value' : null),
            moboFormFactor: (value) => (getPCComponentQuery?.data?.xCategory === "MAINBOARD" && value.trim().length < 1 ? 'Please select value' : null),
            moboSocket: (value) => (getPCComponentQuery?.data?.xCategory === "MAINBOARD" && value.trim().length < 1 ? 'Please select value' : null),
            moboRamType: (value) => (getPCComponentQuery?.data?.xCategory === "MAINBOARD" && value.trim().length < 1 ? 'Please select value' : null),

            //  RAM
            ramType: (value) => (getPCComponentQuery?.data?.xCategory === "RAM" && value.trim().length < 1 ? 'Please select value' : null),
            ramDDR: (value) => (getPCComponentQuery?.data?.xCategory === "RAM" && value.trim().length < 1 ? 'Please select value' : null),
            ramAmount: (value) => (getPCComponentQuery?.data?.xCategory === "RAM" && value < 1 ? 'Invalid value' : null),

            //  COOLER
            coolerHeatExchangeMedium: (value) => ((getPCComponentQuery?.data?.xCategory === "COOLER" || getPCComponentQuery?.data?.xCategory === "WATER COOLING") && value.trim().length < 1 ? 'Please select value' : null),
            coolerType: (value) => ((getPCComponentQuery?.data?.xCategory === "COOLER" || getPCComponentQuery?.data?.xCategory === "WATER COOLING") && value.trim().length < 1 ? 'Please select value' : null),
            coolerHeight: (value, values) => ((getPCComponentQuery?.data?.xCategory === "COOLER" || getPCComponentQuery?.data?.xCategory === "WATER COOLING") && values.coolerType === "TOWER" && value < 1 ? 'Invalid value' : null),
            coolerRadiatorLength:(value, values) => ((getPCComponentQuery?.data?.xCategory === "COOLER" || getPCComponentQuery?.data?.xCategory === "WATER COOLING") && values.coolerType === "AIO" && value < 1 ? 'Invalid value' : null),
            // coolerSocket: "",

            //  PSU
            // psuPCIE5: false,
            psuFormFactor: (value) => (getPCComponentQuery?.data?.xCategory === "POWER SUPPLY" && value.trim().length < 1 ? 'Please select value' : null),
            psu80PlusStandard: (value) => (getPCComponentQuery?.data?.xCategory === "POWER SUPPLY" && value.trim().length < 1 ? 'Please select value' : null),
            psuWattage: (value) => (getPCComponentQuery?.data?.xCategory === "POWER SUPPLY" && value < 1 ? 'Invalid value' : null),

            //  CASE
            caseFormFactor: (value) => (getPCComponentQuery?.data?.xCategory === "CASING" && value.trim().length < 1 ? 'Please select value' : null),
            casePsuFormFactor: (value) => (getPCComponentQuery?.data?.xCategory === "CASING" && value.trim().length < 1 ? 'Please select value' : null),
            caseGpuLength: (value) => (getPCComponentQuery?.data?.xCategory === "CASING" && value < 1 ? 'Invalid value' : null),
            caseCoolerHeight: (value) => (getPCComponentQuery?.data?.xCategory === "CASING" && value < 1 ? 'Invalid value' : null),
            caseRadiatorLength:(value) => (getPCComponentQuery?.data?.xCategory === "CASING" && value < 1 ? 'Invalid value' : null),

            //  SSD
            ssdM2Type: (value) => (getPCComponentQuery?.data?.xCategory === "SSD INT" && value.trim().length < 1 ? 'Please select value' : null),
            ssdCapacity: (value) => (getPCComponentQuery?.data?.xCategory === "SSD INT" && value.trim().length < 1 ? 'Please fill in the fields' : null),
            ssdSize: (value) => (getPCComponentQuery?.data?.xCategory === "SSD INT" && value.trim().length < 1 ? 'Please fill in the fields' : null),

        },
    });

    const updatePCComponentMutation = useMutation(
        (data: any) => {
            setIsLoading(true)
            return axiosPrivate.post("/api/admin/pc-components/update", data, {headers: {'Content-Type': 'multipart/form-data'}})},
        {
            onSuccess: (res: any) => {
                queryClient.invalidateQueries({ queryKey: ['getPCComponent'] })
                setImgFile(null)
                setIsLoading(false);
                showSuccessAlert("PC Component Successfully Updated");
            },
            onError:(err: any) => {
                // setAddRebateFormVisible(false);
                setIsLoading(false);
                let errMsg = err?.response?.data?.message
                showErrorAlert(errMsg ? errMsg : 'An error has occured');
            }
        }
    );


    const [imgFile, setImgFile] = useState<any>(null);
    const [previewImg, setPreviewImg] = useState<string | null>(null)


    const handleUpdateChanges = (data: any) => {
        // console.log(data)

        // updatePCComponentMutation.mutate({
        //     title: data?.title,
        //     amount: data?.amount,
        //     remarks: data?.remarks,
        //     terms_id: data?.terms_id,
        //     image: imgFile ? imgFile : null,
        // })

        if(!imgFile && !data.imgSrc) {
            // console.log('Please upload image')
            showErrorAlert('Please Upload Image')
            return;
        }

        updatePCComponentMutation.mutate({...data, cpuChipset: data.cpuChipset.length > 0 ? JSON.stringify(data?.cpuChipset) : null, images: imgFile})
    };


    const imageDropzoneRef = useRef<() => void>(null);

    const handleImageUpload = (files: File[]) => {
        const file = files[0];
        if (file) {
            setImgFile(file)
        };
    }

    useEffect(() => {
        if (!imgFile) {
            setPreviewImg(null)
            return
        }

        const objectUrl = URL.createObjectURL(imgFile)
        setPreviewImg(objectUrl)

        return () => URL.revokeObjectURL(objectUrl)
    }, [imgFile])

  return (
    <div>
        <div>
            <Header title="PC Component - Edit" />
            {isLoading && (
                <div className={classes.loadingOverlay}>
                <Loader size="xl" />
                </div>
            )}
            <Breadcrumbs mx={20} my={'sm'}>
                <Anchor component={Link} to={`/${location.pathname.split("/")[1]}`}>
                    PC Components {location.pathname.split("/")[1] === 'pc-component-incomplete' ? '(Incomplete)' : null}
                </Anchor>
                <Anchor>
                    Edit
                </Anchor>
            </Breadcrumbs>
            <Box
                w={
                    window.innerWidth -
                    document.getElementById("nav-bar")!!.getBoundingClientRect().width
                }
                mt={"md"}
                
            >
                <Paper px={20}>
                    <Grid>
                        <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                            <Skeleton visible={getPCComponentQuery.isFetching || getPCComponentQuery.isError} animate={!getPCComponentQuery.isError}>
                            <form onSubmit={form.onSubmit((values) => handleUpdateChanges(values))}>
                            <Stack gap={'sm'}>
                                <div>
                                    <Text fw={500} fz={15}>Image <span className={classes.format}>(.jpg, .png)</span> <span style={{color: '#F03E3E'}}>*</span></Text>
                                    <Text fw={500} fz={12} c={'#5d5d5d'}>500px x 500px</Text>
                                    <Dropzone
                                    onDrop={handleImageUpload}
                                    accept={["image/*"]}
                                    openRef={imageDropzoneRef}
                                    >
                                    <div className={classes.thumbnailContainer}>
                                        {previewImg || form.values.imgSrc ? (
                                        <img
                                            src={!previewImg ? form.values.imgSrc : previewImg}
                                            alt="Image"
                                            className={classes.thumbnailSize}
                                        />
                                        ) : (
                                        <p>
                                            <IconPhoto />
                                        </p>
                                        )}
                                    </div>
                                    </Dropzone>
                                </div>
                                <Group>
                                {!previewImg ?
                                    <Button onClick={() => imageDropzoneRef.current?.()} leftSection={<IconPhoto />} fullWidth>Upload Image</Button>
                                : 
                                    <Button onClick={() => setImgFile(null)} leftSection={<IconPhotoCancel />} fullWidth color="gray">Remove Image</Button>
                                }
                                </Group>
                                <TextInput
                                    label="Display Name"
                                    placeholder="Input Display Name"
                                    withAsterisk
                                    {...form.getInputProps('displayName')}
                                    disabled={updatePCComponentMutation.isLoading}
                                />
                                <div style={{display: 'flex', flexDirection: 'column'}}>
                                <Text fw={500} fz={14}>Price</Text>
                                <Code>
                                    {
                                        getPCComponentQuery.data?.priceScheme
                                    }
                                </Code>
                                </div>
                                {/* <NumberInput
                                    label="Price"
                                    placeholder="Input Price"
                                    allowNegative={false}
                                    decimalScale={2}
                                    withAsterisk
                                    {...form.getInputProps('price')}
                                    disabled={updatePCComponentMutation.isLoading}
                                /> */}
                                {/* <NumberInput
                                    label="Height"
                                    allowNegative={false}
                                    allowDecimal={false}
                                    placeholder="Input Height"
                                    description="Optional"
                                    withAsterisk
                                    {...form.getInputProps('height')}
                                />
                                <NumberInput
                                    label="Width"
                                    allowNegative={false}
                                    allowDecimal={false}
                                    placeholder="Input Width"
                                    description="Optional"
                                    withAsterisk
                                    {...form.getInputProps('width')}
                                />
                                <NumberInput
                                    label="Weight"
                                    allowNegative={false}
                                    allowDecimal={false}
                                    placeholder="Input Weight"
                                    description="Optional"
                                    withAsterisk
                                    {...form.getInputProps('weight')}
                                /> */}
                                <div>
                                <Text fw={500} fz={14}>Show Component In Custom Build Selection?</Text>
                                <Checkbox
                                    defaultChecked
                                    label="Show"
                                    {...form.getInputProps('show', {type: 'checkbox'})}
                                    disabled={updatePCComponentMutation.isLoading}
                                />
                                </div>

                                {getPCComponentQuery?.data?.xCategory === 'FAN' || getPCComponentQuery?.data?.xCategory === 'OS' 
                                ? null 
                                : <Divider my="xs" label={`${getPCComponentQuery?.data?.xCategory}`} labelPosition="center" color="dark.3"/>
                                }

                                {/* /CPU */}
                                {
                                getPCComponentQuery?.data?.xCategory === "PROCESSOR" ?
                                <>
                                    <NumberInput
                                        label="CPU MAX TDP"
                                        allowNegative={false}
                                        allowDecimal={false}
                                        placeholder="Input CPU TDP"
                                        withAsterisk
                                        {...form.getInputProps('cpuTdp')}
                                        disabled={updatePCComponentMutation.isLoading}
                                    />
                                    <Select
                                        label="CPU Socket"
                                        placeholder="Select CPU Socket"
                                        withAsterisk
                                        data={getItemParamsQuery?.data?.cpuSocket ? getItemParamsQuery?.data?.cpuSocket : []}
                                        {...form.getInputProps('cpuSocket')}
                                        disabled={updatePCComponentMutation.isLoading}
                                    />
                                    <MultiSelect
                                        label="CPU Chipset"
                                        description="Can select multiple"
                                        placeholder="Select CPU Chipset"
                                        withAsterisk
                                        data={getItemParamsQuery?.data?.cpuChipset ? getItemParamsQuery?.data?.cpuChipset : []}
                                        {...form.getInputProps('cpuChipset')}
                                        disabled={updatePCComponentMutation.isLoading}
                                    />
                                </>
                                : null
                                }
                                {/* CPU/ */}

                                {/* /GPU */}
                                {
                                getPCComponentQuery?.data?.xCategory === "VGA" ?
                                <>
                                    <Select
                                        label="GPU model"
                                        description="Necessary for displaying FPS."
                                        placeholder="Select GPU model"
                                        withAsterisk
                                        data={getItemParamsQuery?.data?.gpuModel ? getItemParamsQuery?.data?.gpuModel : []}
                                        searchable
                                        {...form.getInputProps('gpuModel')}
                                        disabled={updatePCComponentMutation.isLoading}
                                    />
                                    <NumberInput
                                        label="GPU Length (mm)"
                                        allowNegative={false}
                                        allowDecimal={false}
                                        placeholder="Input GPU Length (mm)"
                                        withAsterisk
                                        {...form.getInputProps('gpuLength')}
                                        disabled={updatePCComponentMutation.isLoading}
                                    />
                                    <NumberInput
                                        label="Recommended PSU Wattage"
                                        allowNegative={false}
                                        allowDecimal={false}
                                        placeholder="Input Recommended PSU Wattage"
                                        withAsterisk
                                        {...form.getInputProps('gpuRecommendedPsu')}
                                        disabled={updatePCComponentMutation.isLoading}
                                    />
                                </>
                                : null
                                }
                                {/* GPU/ */}

                                {/* /MOBO */}
                                {
                                getPCComponentQuery?.data?.xCategory === "MAINBOARD" ?
                                <>
                                    <Select
                                        label="Mobo Chipset"
                                        placeholder="Select MOBO Chipset"
                                        withAsterisk
                                        data={getItemParamsQuery?.data?.cpuChipset ? getItemParamsQuery?.data?.cpuChipset : []}
                                        {...form.getInputProps('moboChipset')}
                                        disabled={updatePCComponentMutation.isLoading}
                                    />
                                    <Select
                                        label="Mobo Form Factor"
                                        placeholder="Select MOBO Form Factor"
                                        withAsterisk
                                        data={["ITX", "MATX", "ATX", "EATX"]}
                                        {...form.getInputProps('moboFormFactor')}
                                        disabled={updatePCComponentMutation.isLoading}
                                    />
                                    <Select
                                        label="Mobo Socket"
                                        placeholder="Select Mobo Socket"
                                        withAsterisk
                                        data={getItemParamsQuery?.data?.cpuSocket ? getItemParamsQuery?.data?.cpuSocket : []}
                                        {...form.getInputProps('moboSocket')}
                                        disabled={updatePCComponentMutation.isLoading}
                                    />
                                    <Select
                                        label="MOBO Ram Type"
                                        placeholder="Select MOBO Ram Type"
                                        withAsterisk
                                        data={getItemParamsQuery?.data?.ramDDR ? getItemParamsQuery?.data?.ramDDR : []}
                                        {...form.getInputProps('moboRamType')}
                                        disabled={updatePCComponentMutation.isLoading}
                                    />
                                </>
                                : null
                                }
                                {/* MOBO/ */}

                                {/* /RAM */}
                                {
                                getPCComponentQuery?.data?.xCategory === "RAM" ?
                                <>
                                    <Select
                                        label="Ram Type"
                                        placeholder="Select Ram Type"
                                        withAsterisk
                                        data={["DESKTOP","NOTEBOOK"]}
                                        {...form.getInputProps('ramType')}
                                        disabled={updatePCComponentMutation.isLoading}
                                    />
                                    <Select
                                        label="RAM DDR Type"
                                        placeholder="Select RAM DDR Type"
                                        withAsterisk
                                        data={getItemParamsQuery?.data?.ramDDR ? getItemParamsQuery?.data?.ramDDR : []}
                                        {...form.getInputProps('ramDDR')}
                                        disabled={updatePCComponentMutation.isLoading}
                                    />
                                    <NumberInput
                                        label="Ram Amount"
                                        description="*Number of Ram Stick"
                                        allowNegative={false}
                                        allowDecimal={false}
                                        placeholder="Input Ram Amount"
                                        withAsterisk
                                        {...form.getInputProps('ramAmount')}
                                        disabled={updatePCComponentMutation.isLoading}
                                    />
                                </>
                                : null
                                }
                                {/* RAM/ */}

                                {/* /COOLER */}
                                {
                                (getPCComponentQuery?.data?.xCategory === "COOLER" || getPCComponentQuery?.data?.xCategory === "WATER COOLING") ?
                                <>
                                    <Select
                                        label="Cooler Heat Exchange Medium"
                                        placeholder="Select Cooler Heat Exchange Medium"
                                        withAsterisk
                                        data={getItemParamsQuery?.data?.coolerHeatExchangeMedium ? getItemParamsQuery?.data?.coolerHeatExchangeMedium : []}
                                        {...form.getInputProps('coolerHeatExchangeMedium')}
                                        disabled={updatePCComponentMutation.isLoading}
                                    />
                                    <Select
                                        label="Cooler Type"
                                        placeholder="Select Cooler Type"
                                        withAsterisk
                                        data={getItemParamsQuery?.data?.coolerType ? getItemParamsQuery?.data?.coolerType : []}
                                        {...form.getInputProps('coolerType')}
                                        disabled={updatePCComponentMutation.isLoading}
                                    />
                                    {
                                        form.values.coolerType === "TOWER" ? 
                                        <NumberInput
                                            label="Cooler Height (mm)"
                                            allowNegative={false}
                                            allowDecimal={false}
                                            placeholder="Input Cooler Height (mm)"
                                            withAsterisk
                                            {...form.getInputProps('coolerHeight')}
                                            disabled={updatePCComponentMutation.isLoading}
                                        />
                                        : null
                                    }
                                    {
                                        form.values.coolerType === "AIO" ? 
                                        <NumberInput
                                            label="Cooler Radiator Length (mm)"
                                            allowNegative={false}
                                            allowDecimal={false}
                                            placeholder="Input Cooler Radiator Length (mm)"
                                            withAsterisk
                                            {...form.getInputProps('coolerRadiatorLength')}
                                            disabled={updatePCComponentMutation.isLoading}
                                        />
                                        : null
                                    }
                                    {/* <Select
                                        label="Cooler Socket"
                                        placeholder="Select Cooler Socket"
                                        withAsterisk
                                        data={getItemParamsQuery?.data?.cpuSocket ? getItemParamsQuery?.data?.cpuSocket : []}
                                        {...form.getInputProps('coolerSocket')}
                                    /> */}
                                </>
                                : null
                                }
                                {/* COOLER/ */}

                                {/* /PSU */}
                                {
                                getPCComponentQuery?.data?.xCategory === "POWER SUPPLY" ?
                                <>
                                    <div>
                                    <Text fw={500} fz={14}>PSU PCIe 5 ?</Text>
                                    <Checkbox
                                        defaultChecked
                                        label="PSU PCIe 5"
                                        {...form.getInputProps('psuPCIE5', {type: 'checkbox'})}
                                        disabled={updatePCComponentMutation.isLoading}
                                    />
                                    </div>
                                    <Select
                                        label="PSU Form Factor"
                                        placeholder="Select PSU Form Factor"
                                        withAsterisk
                                        data={getItemParamsQuery?.data?.psuFormFactor ? getItemParamsQuery?.data?.psuFormFactor : []}
                                        {...form.getInputProps('psuFormFactor')}
                                        disabled={updatePCComponentMutation.isLoading}
                                    />
                                    <Select
                                        label="PSU 80 Plus Standard"
                                        placeholder="Select PSU 80 Plus Standard"
                                        withAsterisk
                                        data={getItemParamsQuery?.data?.psu80PlusStandard ? getItemParamsQuery?.data?.psu80PlusStandard : []}
                                        {...form.getInputProps('psu80PlusStandard')}
                                        disabled={updatePCComponentMutation.isLoading}
                                    />
                                    <NumberInput
                                        label="PSU Wattage"
                                        allowNegative={false}
                                        allowDecimal={false}
                                        placeholder="Input PSU Wattage"
                                        withAsterisk
                                        {...form.getInputProps('psuWattage')}
                                        disabled={updatePCComponentMutation.isLoading}
                                    />
                                </>
                                : null
                                }
                                {/* PSU/ */}

                                {/* /CASE */}
                                {
                                getPCComponentQuery?.data?.xCategory === "CASING" ?
                                <>
                                    <Select
                                        label="Case Form Factor"
                                        placeholder="Select Case Form Factor"
                                        withAsterisk
                                        data={["ITX", "MATX", "ATX", "EATX"]}
                                        {...form.getInputProps('caseFormFactor')}
                                        disabled={updatePCComponentMutation.isLoading}
                                    />
                                    <Select
                                        label="Case PSU Form Factor"
                                        placeholder="Select Case PSU Form Factor"
                                        withAsterisk
                                        data={getItemParamsQuery?.data?.psuFormFactor ? getItemParamsQuery?.data?.psuFormFactor : []}
                                        {...form.getInputProps('casePsuFormFactor')}
                                        disabled={updatePCComponentMutation.isLoading}
                                    />
                                    <NumberInput
                                        label="Case GPU Length (mm)"
                                        allowNegative={false}
                                        allowDecimal={false}
                                        placeholder="Input Case GPU Length (mm)"
                                        withAsterisk
                                        {...form.getInputProps('caseGpuLength')}
                                        disabled={updatePCComponentMutation.isLoading}
                                    />
                                    <NumberInput
                                        label="Case Cooler Height (mm)"
                                        allowNegative={false}
                                        allowDecimal={false}
                                        placeholder="Input Case Cooler Height (mm)"
                                        withAsterisk
                                        {...form.getInputProps('caseCoolerHeight')}
                                        disabled={updatePCComponentMutation.isLoading}
                                    />
                                    <NumberInput
                                        label="Case Radiator Length (mm)"
                                        allowNegative={false}
                                        allowDecimal={false}
                                        placeholder="Input Case Radiator Length (mm)"
                                        withAsterisk
                                        {...form.getInputProps('caseRadiatorLength')}
                                        disabled={updatePCComponentMutation.isLoading}
                                    />
                                </>
                                : null
                                }
                                {/* CASE/ */}

                                {/* /SSD */}
                                {
                                getPCComponentQuery?.data?.xCategory === "SSD INT" ?
                                <>
                                    <Select
                                        label="SSD M2 Type"
                                        placeholder="Select SSD M2 Type"
                                        withAsterisk
                                        data={getItemParamsQuery?.data?.ssdM2Type ? getItemParamsQuery?.data?.ssdM2Type : []}
                                        {...form.getInputProps('ssdM2Type')}
                                        disabled={updatePCComponentMutation.isLoading}
                                    />
                                    <TextInput
                                        label="Input SSD Capacity"
                                        description="Eg. 256GB"
                                        placeholder="Input SSD Capacity"
                                        withAsterisk
                                        {...form.getInputProps('ssdCapacity')}
                                        disabled={updatePCComponentMutation.isLoading}
                                    />
                                    <TextInput
                                        label="Input SSD Size"
                                        description="Eg. 2242 / 2280"
                                        placeholder="Input SSD Size"
                                        withAsterisk
                                        {...form.getInputProps('ssdSize')}
                                        disabled={updatePCComponentMutation.isLoading}
                                    />
                                </>
                                : null
                                }
                                {/* CASE/ */}


                                <Group justify="flex-end" mt="md">
                                    <Button type="submit" loading={updatePCComponentMutation.isLoading}>Update PC Component</Button>
                                </Group>
                            </Stack>
                            </form>
                            </Skeleton>
                        </Grid.Col>
                    </Grid>
                </Paper>
            </Box>
        </div>
    </div>
  );
}

export default PCComponentEdit;
